function vacancyFormBtn() {
	const button = document.querySelector(".vacancy-form-submit");
	if (button) {
		button.addEventListener("click", function() {
			MicroModal.show("modal--thank-you", {
				awaitCloseAnimation: true,
				disableScroll: true,
			});
		});
	}
}
